var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"add-users"}},[_c('vx-card',[_c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-card',{staticClass:"flex-fill"},[_c('user-profile-form',{attrs:{"form-data":this.$store.state.AppActiveUser}})],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }